module.exports = __webpack_public_path__ + "img/logo.5e024113.png";